import { isNil } from "lodash";
import { useBookingModuleContext } from "PFApp/booking/parts/providers/booking_module_context_provider";
import { getFullKey } from "PFCore/helpers/use_storage";
import { useWorkforceMetrics } from "PFCore/hooks/queries/workforce_metrics";
import { Filters } from "PFTypes";
import { useMemo } from "react";

import { useBookingsOverviewContext } from "../context/bookings_overview_context";
import { getStoragePrefix } from "../use_workforce_data";
import { calculateMetricValue, getMetricDisplayValue } from "./use_metric_value.utils";

interface UseMetricValueReturn {
  metricValue: number | undefined;
  metricDisplayValue: string | undefined;
  isLoading: boolean;
}

export const useMetricValue = (): UseMetricValueReturn => {
  const { workforceMetricsMode } = useBookingsOverviewContext();
  const { calendarRange } = useBookingModuleContext();
  const selectedFilters = window.storage.getItem(getFullKey(`${getStoragePrefix()}_selectedValueFilters`));
  const { data: workforceMetrics, isLoading } = useWorkforceMetrics({
    calendarRange,
    filters: selectedFilters as Filters,
    options: {
      keepPreviousData: true
    }
  });

  const [metricValue, metricDisplayValue] = useMemo(() => {
    const value = calculateMetricValue(workforceMetricsMode, workforceMetrics);
    const displayValue = getMetricDisplayValue(workforceMetricsMode, workforceMetrics);
    return !isNil(value) ? [value, displayValue] : [];
  }, [workforceMetricsMode, workforceMetrics]);

  return { metricValue, metricDisplayValue, isLoading: isLoading };
};
